import { render, staticRenderFns } from "./Microfront.vue?vue&type=template&id=3a5bd6af&scoped=true"
import script from "./Microfront.vue?vue&type=script&lang=js"
export * from "./Microfront.vue?vue&type=script&lang=js"
import style0 from "./Microfront.vue?vue&type=style&index=0&id=3a5bd6af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5bd6af",
  null
  
)

export default component.exports